<template>
    <div class="nothing-here">
        <span class="nothing-here__no-items-text" v-html="content"></span>
        <TotemButton
            @click="goToRecommendations"
            size="medium"
            color="primary"
            class="nothing-here__see-recommendations"
            :label="getButtonText"
        />
    </div>
</template>

<script>
    export default {
        props: {
            content: String,
            type: {
                type: String,
                default: 'courses'
            }
        },
        inject: {
            activateTab: {
                from: 'activateTab',
                default: null
            },
            recommendedTabId: {
                from: 'recommendedTabId',
                default: ''
            }
        },
        computed: {
            getButtonText () {
                return this.type === 'courses' ? this.$t('General.see_our_recommendations_button_label') : this.$t('LandingPage.explore_learning_paths')
            }
        },
        methods: {
            goToRecommendations () {
                if (this.type === 'courses') {
                    this.activateTab ? this.activateTab(this.recommendedTabId) : this.$router.push({ name: 'home-courses' })
                } else {
                    this.$router.push({ name: 'all-packages-learning-paths' })
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.nothing-here {
    &__no-items-text {
        font-size: 2rem;
        display: block;
        margin: 10px 0;
        animation: noItemsAnimation 0.25s;
        animation-timing-function: ease-in-out;
        font-weight: 300;
    }

    @keyframes noItemsAnimation {
        0% {
            transform: translate3d(0, 5px, 0);
        }
        100% {
            transform: translate3d(0, 0, 0);
        }
    }

    &__see-recommendations {
        margin: 20px 0;
        font-family: 'Quicksand-Regular';
    }
}
</style>
